/**
 * Validate a string value against a max numerical limit
 *
 * @param field
 * @param maxValue
 * @returns {boolean}
 */
export default function (field, maxValue) {
	const stringValue = typeof field.value === 'string'
		? field.value
		: field.value.toString()

	const numericValue = Number(stringValue.replace(/,/g, ''))
	return numericValue <= maxValue
}
